import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="sortable-list"
export default class extends Controller {
  static values = {
    url: String,          // URL to POST new order
    handle: String        // Optional: CSS selector for drag handle
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: this.hasHandleValue ? this.handleValue : null,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      forceFallback: true,  // Better mobile support
      fallbackClass: "sortable-fallback",
      fallbackOnBody: true,
      swapThreshold: 0.65,
      
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  }

  async onEnd(event) {
    // Get all item IDs in new order
    const items = Array.from(this.element.children)
    const orderedIds = items.map(item => item.dataset.participantId).filter(Boolean)

    if (orderedIds.length === 0) return

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken(),
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: JSON.stringify({
          ordered_participant_ids: orderedIds
        })
      })

      if (!response.ok) {
        throw new Error("Failed to update order")
      }

      // Turbo Streams will handle the response
    } catch (error) {
      console.error("Error updating order:", error)
      // Revert to original order on error
      this.sortable.option("disabled", true)
      location.reload()
    }
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
  }
}

